import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { FiUpload, FiShield, FiRepeat, FiSearch, FiBarChart2, FiDollarSign } from "react-icons/fi";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <FAQContainer>
      {/* Title centered */}
      <TopHeader>
        <FAQTitle>Masz pytania? My mamy odpowiedzi!</FAQTitle>
      </TopHeader>

      {/* Content only (no image) */}
      <ContentWrapper>
        <FAQContent>
          <FAQList>
            {faqItems.map((item, index) => (
              <FAQItem key={index}>
                <Question onClick={() => toggleFAQ(index)}>
                  <IconWrapper>{item.icon}</IconWrapper>
                  <QuestionText>{item.question}</QuestionText>
                  <Arrow>{activeIndex === index ? "▲" : "▼"}</Arrow>
                </Question>
                <Answer $isOpen={activeIndex === index}>{item.answer}</Answer>
              </FAQItem>
            ))}
          </FAQList>
        </FAQContent>
      </ContentWrapper>
    </FAQContainer>
  );
};

export default FAQ;

/* ---------- data ---------- */

const faqItems = [
  {
    question: "Jak załadować plik JPK VAT?",
    answer:
      "Aby załadować plik JPK VAT, przejdź do panelu użytkownika, kliknij „Dodaj plik” i wybierz odpowiedni plik XML z dysku. System automatycznie rozpocznie analizę danych.",
    icon: <FiUpload />,
  },
  {
    question: "Czy moje dane są bezpieczne?",
    answer:
      "Tak, wszystkie dane są przesyłane z użyciem bezpiecznego szyfrowania SSL i przechowywane w chronionym środowisku zgodnym z RODO.",
    icon: <FiShield />,
  },
  {
    question: "Czy mogę zmienić plan subskrypcji?",
    answer:
      "Oczywiście. Możesz w każdej chwili zmienić swój plan w ustawieniach konta – przejście na wyższy lub niższy plan następuje automatycznie.",
    icon: <FiRepeat />,
  },
  {
    question: "Jak mogę sprawdzić kontrahenta?",
    answer:
      "Wystarczy wpisać numer NIP kontrahenta w odpowiednim polu. Nasz system automatycznie pobierze dane z bazy GUS i wyświetli szczegóły.",
    icon: <FiSearch />,
  },
  {
    question: "Jakie raporty są dostępne?",
    answer:
      "System generuje raporty dzienne, miesięczne, roczne, a także analizy kontrahentów i regionów.",
    icon: <FiBarChart2 />,
  },
  {
    question: "Jak działa płatność i fakturowanie?",
    answer:
      "Płatności są cykliczne (miesięczne), a faktury VAT są dostępne do pobrania z poziomu panelu użytkownika.",
    icon: <FiDollarSign />,
  },
];

/* ---------- styles ---------- */

const slideDown = keyframes`
  0% { opacity: 0; transform: translateY(-5px); }
  100% { opacity: 1; transform: translateY(0); }
`;

const FAQContainer = styled.div`
  padding: 3rem 1rem;
  background: url("/back.jpg") no-repeat center center fixed;
  background-size: cover;
  text-align: left;
  backdrop-filter: brightness(0.95);

  /* For full transparency instead:
     background: transparent; backdrop-filter: none; */
`;

const TopHeader = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem 1.5rem;
  text-align: center;
`;

const FAQTitle = styled.h2`
  font-size: 2.8rem;
  font-weight: 800;
  color: #1f2937;
  margin: 0;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

/* Single-column content wrapper (no image now) */
const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const FAQContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const FAQList = styled.div`
  width: 100%;
`;

const FAQItem = styled.div`
  margin-bottom: 1.8rem;
`;

const Question = styled.div`
  display: grid;
  grid-template-columns: 2rem 1fr 1.5rem;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  font-size: 1.3rem;
  font-weight: bold;
  color: #111827;

  &:hover {
    color: #3bc3cc;
  }

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const IconWrapper = styled.div`
  font-size: 1.4rem;
  color: #3bc3cc;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 1.8rem;
`;

const QuestionText = styled.span`
  text-align: left;
`;

const Arrow = styled.span`
  font-size: 1.2rem;
`;

const Answer = styled.div`
  margin-top: ${({ $isOpen }) => ($isOpen ? "0.5rem" : "0")};
  font-size: 1.1rem;
  color: #4b5563;
  max-height: ${({ $isOpen }) => ($isOpen ? "300px" : "0")};
  overflow: hidden;
  transition: max-height 0.4s ease, margin-top 0.4s ease;
  animation: ${({ $isOpen }) => ($isOpen ? slideDown : "none")} 0.4s ease;
  padding-left: 2.5rem;
  line-height: 1.75;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;
